import type React from "react";

export const RequiredBadge: React.FC = () => {
	return (
		<span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded ml-2 font-normal">
			必須
		</span>
	);
};
